import { api } from "./client";

export const modulesApi = {
  list: () => api.get("/modules").then((r) => r.data.modules),
  listAll: () => api.get("/modules/all").then((r) => r.data.modules),
};
